// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607200007/js/" + chunkId + "." + {"44":"cc611a1d","225":"21cefd30","481":"f52631b6","486":"806d4529","770":"6c298d97"}[chunkId] + ".0.8775023856227017.chunk.js";
};